import anime from 'animejs/lib/anime.es.js';

export default class MobileNav {
    constructor() {
        this._animationDuration = 350;
        this._isNavOpen = false;
        this._isSubNavOpen = false;
        this._isSearchOpen = false;
        this._navTrigger = document.getElementById('mobile-nav-trigger');
        this._navHamburger = document.getElementById('mobile-nav-hamburger');
        this._mobileNavigation = document.getElementById('main-navigation');
        this._navSearchTrigger = document.getElementById('nav-search-trigger');
        this._mainNav = document.querySelector('.nav__main__items');
        this._mainNavSubButtons = Array.from(document.querySelectorAll('.nav__main__items .menu-item-has-children'));
        this._subNavs = Array.from(document.querySelectorAll('.nav__main__items ul.submenu'));
        this._mobileBaseHeight = 190;
        this._baseHeight = 81;
        this._classTimeout = null;
        this._isMobile = true;
        window.addEventListener('resize', this.doResize.bind(this));
        this.doResize();
    }

    doResize() {
        const willMobile = window.innerWidth < 960;
        if (willMobile != this._isMobile) {
            if (willMobile) {
                if (this._isSubNavOpen) {
                    this.displaySubNav(false, null, true);
                }
                document.querySelector('.nav__main__items').style.height = this._mobileBaseHeight + 'px';
            } else {
                // we might close any open nav
                if (this._isSubNavOpen) {
                    this.displaySubNav(false, null, true);
                }
                if (this._isNavOpen) {
                    this.openNav(false);
                }
                document.querySelector('.nav__main__items').style.height = 'auto';
            }
        }
        this._isMobile = willMobile;
    }

    render() {
        if (this._navTrigger) {
            this._navTrigger.addEventListener(
                'click',
                () => {
                    this.openNav(!this._isNavOpen);
                },
                false,
            );
        }
        if (this._navSearchTrigger) {
            this._navSearchTrigger.addEventListener(
                'click',
                () => {
                    this.openSearch(!this._isSearchOpen);
                },
                false,
            );
        }
        const anchorLinks = Array.from(document.querySelectorAll('a[href^="#"]'));
        anchorLinks.forEach((item) => {
            if (!item.parentNode.classList.contains('menu-item'))
                item.addEventListener(
                    'click',
                    (e) => {
                        this.openNav(false);
                        e.preventDefault();
                        var topVal =
                            document.querySelector(e.currentTarget.getAttribute('href')).getBoundingClientRect().top +
                            (window.scrollY || window.pageYOffset);
                        this.doScrolling(topVal - 55, 500);
                    },
                    false,
                );
        });

        this._mainNavSubButtons.forEach((item) => {
            item.addEventListener(
                'click',
                (e) => {
                    if (!e.currentTarget.classList.contains('active')) {
                        e.preventDefault();
                        Array.from(document.querySelectorAll('.nav__main__items .menu-item-has-children')).forEach(
                            (item) => item.classList.remove('active'),
                        );
                        e.currentTarget.classList.add('active');
                        this.displaySubNav(true, e.currentTarget);
                    }
                },
                false,
            );
        });

        this._mainNavSubButtons.forEach((item) => {
            item.addEventListener(
                'mouseover',
                (e) => {
                    if (this._isMobile) return;
                    if (!e.currentTarget.classList.contains('active')) {
                        e.preventDefault();
                        Array.from(document.querySelectorAll('.nav__main__items .menu-item-has-children')).forEach(
                            (item) => item.classList.remove('active'),
                        );
                        e.currentTarget.classList.add('active');
                        this.displaySubNav(true, e.currentTarget);
                    }
                },
                false,
            );
        });

        this._mainNavSubButtons.forEach((item) => {
            item.addEventListener(
                'mouseout',
                (e) => {
                    if (this._isMobile) return;
                    if (e.currentTarget.classList.contains('active')) {
                        e.preventDefault();
                        Array.from(document.querySelectorAll('.nav__main__items .menu-item-has-children')).forEach(
                            (item) => item.classList.remove('active'),
                        );
                        this.displaySubNav(false, null);
                    }
                },
                false,
            );
        });

        const mainNavBackButtons = Array.from(document.querySelectorAll('.nav__main__items .back-btn'));
        mainNavBackButtons.forEach((item) => {
            item.addEventListener(
                'click',
                (e) => {
                    this.displaySubNav(false, null);
                    e.preventDefault();
                    e.stopPropagation();
                },
                false,
            );
        });

        const searchBackButtons = Array.from(
            document.querySelectorAll('.search__form__form__container .nav-back-button'),
        );
        searchBackButtons.forEach((item) => {
            item.addEventListener(
                'click',
                (e) => {
                    this.openSearch(false);
                    e.preventDefault();
                    e.stopPropagation();
                },
                false,
            );
        });

        Array.from(document.querySelectorAll('.search__form__close')).forEach((item) => {
            item.addEventListener(
                'click',
                (e) => {
                    this.openSearch(false);
                    e.preventDefault();
                    e.stopPropagation();
                },
                false,
            );
        });
    }

    displaySubNav(value, target, isDirect = false) {
        this._isSubNavOpen = value;
        clearTimeout(this._classTimeout);
        if (value) {
            this._mainNav.classList.add('display-sub');
        } else {
            this._mainNav.classList.remove('display-sub');
            this._mainNavSubButtons.forEach((item) => {
                item.classList.remove('active');
            });
        }

        let targetHeight = this._isMobile ? this._mobileBaseHeight : this._baseHeight;
        if (target) {
            this._subNavs.forEach((subnav) => {
                subnav.classList.remove('active');
            });
            target.querySelector('ul.submenu').classList.add('active');
            targetHeight = target.querySelector('ul.submenu').offsetHeight;
            if (!this._isMobile) {
                targetHeight += 81; // adding menu height
            }
        }

        if (!value) {
            this._classTimeout = setTimeout(function () {
                if (document.querySelector('ul.submenu.active'))
                    document.querySelector('ul.submenu.active').classList.remove('active');
                if (!this._isMobile) document.querySelector('.nav__main__items').style.height = 'auto';
            }, this._animationDuration + 10);
        }

        if (!isDirect) {
            anime({
                targets: this._mainNav,
                height: targetHeight + 'px',
                easing: 'easeInOutQuad',
                duration: this._animationDuration,
            });
        } else {
            document.querySelector('ul.submenu.active').classList.remove('active');
            document.querySelector('.nav__main__items').style.height = 'auto';
        }
    }

    doScrolling(elementY, duration) {
        var startingY = window.pageYOffset;
        var diff = elementY - startingY;
        var start;
        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) start = timestamp;
            // Elapsed milliseconds since start of scrolling.
            var time = timestamp - start;
            // Get percent of completion in range [0, 1].
            var percent = Math.min(time / duration, 1);
            window.scrollTo(0, startingY + diff * percent);
            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        });
    }
    openSearch(value) {
        this._isSearchOpen = value;
        if (value) {
            document.body.classList.add('with-overlay-search');
            if (this._isMobile) {
                document.querySelector('.search-form-mobile input[type="search"]').focus();
            } else {
                document.querySelector('.search-form-desktop input[type="search"]').focus();
            }
        } else {
            document.body.classList.remove('with-overlay-search');
        }
    }

    openNav(value) {
        this._isNavOpen = value;
        clearTimeout(this.navTimeout);
        if (value) {
            this.navTimeout = setTimeout(
                function () {
                    this._mobileNavigation.classList.add('can-scroll');
                }.bind(this),
                500,
            );
            this._navTrigger.classList.add('is-active');
            this._navHamburger.classList.add('is-active');
            document.body.classList.add('with-overlay-nav');
            this._mobileNavigation.classList.add('active');
        } else {
            this.navTimeout = setTimeout(function () {
                document.body.classList.remove('with-overlay-nav');
            }, 500);
            this._mobileNavigation.classList.remove('active', 'can-scroll');

            this._navTrigger.classList.remove('is-active');
            this._navHamburger.classList.remove('is-active');
        }
    }
}
